import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import controller from "./controller";
import i from "../../../translations/i";
import { storeLocal } from "../../../helpers/stores";
import { Titles } from "../../../layouts/Titles";
import {
  Button,
  Col,
  Divider,
  Input,
  InputNumber,
  Modal,
  Popover,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Tooltip
} from "antd";
import { DeleteOutlined, DownOutlined, EditOutlined, InfoCircleOutlined, UpOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { runInAction } from "mobx";
import { SwitchBlock } from "../../../components/SwitchBlock";
import { SelectProduct, SelectProducts } from "../../../helpers/select_entity/SelectEntity";
import __select from "../../../helpers/select_entity/__select.controller";

export const AdditionalFields = observer(() => {

  useEffect(() => {
    controller.getList()
  }, [])

  const buttons = [
    { title: i.t('def:Additional fields system'), href: `/settings/additional_fields_system`, type: 'dashed' },
    { title: i.t('def:actions.create'), href: `/settings/additional_fields/0`, type: 'primary', plan: 1, black_mark: storeLocal.get('black_mark') }
  ]

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: i.t('def:Field name'), dataIndex: 'field_name', key: 'field_name' },
    { title: i.t('def:Entity type'), dataIndex: 'entity_type', key: 'entity_type', render: (el: string) => el === 'user' ? i.t('additionalFields:entityUser') : i.t('additionalFields:entityOrder') },
    {
      title: i.t('def:Type'),
      dataIndex: 'field_type',
      key: 'field_type',
      render: (type: string) => controller.types.find((el: any) => el.key === type) ? controller.types.find((el: any) => el.key === type).value : type
    },
    {
      key: 'action',
      render: (text: any, record: any) => (
        <Space size="middle">
          <Button
            type="dashed"
            shape="circle"
            icon={<EditOutlined />}
            href={`/settings/additional_fields/${record.id}`}
          />
          <Tooltip title={i.t('categories:top')}><Button type="dashed" shape="circle" icon={<UpOutlined />} onClick={() => controller.setPosition(record.id)} /></Tooltip>
          <Tooltip title={i.t('categories:bottom')}><Button type="dashed" shape="circle" icon={<DownOutlined />} onClick={() => controller.setPosition(record.id, 'down')} /></Tooltip>
          <Button
            type="dashed"
            shape="circle"
            danger
            icon={<DeleteOutlined />}
            onClick={() => controller.delete(record.id)}
          />
        </Space>
      )
    }
  ]

  return(
    <>
      <Titles
        title={i.t('def:Additional fields')}
        buttons={buttons}
      />

      <Table
        columns={columns}
        dataSource={controller.items}
        pagination={false}
      />
    </>
  )
})

export const AdditionalField = observer(() => {

  const { id }: any = useParams()

  useEffect(() => {
    controller.getOne(id)
    controller.getList()
  }, [])

  const buttons = [
    { title: i.t('def:actions.backList'), href: `/settings/additional_fields`, type: 'dashed' },
    { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
  ]



  return(
    <>
      <form onSubmit={(e) => controller.save(e)}>
        <Titles
          title={i.t('def:Edit additional field')}
          buttons={buttons}
        />

        <Row gutter={[20, 20]}>
          <Col span={24}>
            <SwitchBlock array={[
              { label: i.t('def:active'), click: (e: any) => controller.item.enabled = e, value: controller.item.enabled }
            ]} />
          </Col>
          <Col span={12}>
            <label>{i.t('def:Select field type')}</label>
            <Select
              options={controller.types.map((el: any) => ({ label: el.value, value: el.key}))}
              style={{ width: `100%` }}
              value={controller.item.field_type}
              disabled={!!controller.item.id}
              onChange={(e: any) => runInAction(() => controller.item.field_type = e)}
            />
          </Col>
          <Col span={12}>
            <label>{i.t('def:Field name')}</label>
            <Input
              value={controller.item.field_name}
              onChange={(e: any) => runInAction(() => controller.item.field_name = e.target.value)}
            />
          </Col>
          <Col span={12}>
            <label>{i.t('def:Placeholder')}</label>
            <Input
              value={controller.item.placeholder}
              onChange={(e: any) => runInAction(() => controller.item.placeholder = e.target.value)}
            />
          </Col>
          <Col span={12}>
            <label>{i.t('def:Select entity type')}</label>
            <Select
              options={[
                { label: i.t('additionalFields:entityUser'), value: 'user' },
                { label: i.t('additionalFields:entityOrder'), value: 'order' },
              ]}
              style={{ width: `100%` }}
              value={controller.item.entity_type}
              onChange={(e: any) => runInAction(() => controller.item.entity_type = e)}
            />
          </Col>
          <Col span={24}>
            <SwitchBlock array={[
              {
                label: i.t('def:Fill register'),
                click: (e: any) => controller.item.fill_register = e,
                value: controller.item.fill_register,
                disabled: controller.item.entity_type !== 'user' || controller.item.field_type === 'product'
              },
              { label: i.t('def:Required bonus program'), click: (e: any) => controller.item.required_bonus_program = e, value: controller.item.required_bonus_program },
              { label: i.t('def:Required register'), click: (e: any) => controller.item.required_register = e, value: controller.item.required_register, disabled: controller.item.entity_type !== 'user' || controller.item.field_type === 'product' },
              { label: i.t('def:Required fill order'), click: (e: any) => controller.item.required_fill_order = e, value: controller.item.required_fill_order },
              { label: i.t('def:Depending'), click: (e: any) => controller.item.depending = e, value: controller.item.depending },
              { label: i.t('def:Only legal'), click: (e: any) => controller.item.only_legal = e, value: controller.item.only_legal },
            ]} />
          </Col>
          <Divider />

          {controller.item.field_type === 'file' ? (
            <>
              <Col span={24}>
                <SwitchBlock array={[
                  { label: i.t('def:Removable'), click: (e: any) => controller.item.removable = e, value: controller.item.removable },
                ]} />
              </Col>
              <Col span={12}>
                <label>{i.t('def:How long to delete?')}</label>
                <InputNumber
                  style={{ width: `100%` }}
                  value={controller.item.how_long_to_delete}
                  onChange={(e: any) => runInAction(() => controller.item.how_long_to_delete = e)}
                  min={1}
                />
              </Col>
            </>
          ) : <></>}

          {controller.item.depending ? (
            <>
              <Col span={12}>
                <label>{i.t('def:Depending field')}</label>
                <Select
                  options={controller.items.map((el: any) => ({ label: el.field_name ?? el.placeholder, value: el.id}))}
                  style={{ width: `100%` }}
                  value={controller.item.depending_field_id}
                  onChange={(e: any) => runInAction(() => controller.item.depending_field_id = e)}
                />
              </Col>
              <Col span={12}>
                <SwitchBlock array={[
                  { label: i.t('def:Depending value'), click: (e: any) => controller.item.depending_value = e, value: controller.item.depending_value },
                ]} />
              </Col>
            </>
          ) : <></>}

          {(controller.item.field_type === 'select' || controller.item.field_type === 'radio') ? (
            <>
              <Col span={24}>
                <label>{i.t('def:Field options')}</label>
              </Col>
              <Col span={24}>
                <Button type="dashed" onClick={() => controller.addOption()}>{i.t('def:actions.create')}</Button>
              </Col>
              <Col span={24}>
                <Row gutter={[20, 20]}>
                  {controller.item.options.map((el: any, index: number) => (
                    <>
                      <Col span={20}>
                        <Input
                          value={controller.item.options[index].value}
                          onChange={(e: any) => runInAction(() => controller.item.options[index].value = e.target.value)}
                        />
                      </Col>
                      <Col span={4}>
                        <Button onClick={() => controller.deleteOption(index)} danger>{i.t('def:actions.remove')}</Button>
                      </Col>
                    </>
                  ))}
                </Row>
              </Col>
            </>
          ) : <></>}

          {(controller.item.field_type === 'product') ? (
            <>
              <Col span={24}>
                <label>{i.t('additionalFields:selectProductLabel')}</label>
              </Col>
              {controller.item.product_id
                ? <Col span={24}>
                  <a href={`/shop/catalog/product/${controller.item.product_id}`} target="_blank">{i.t('additionalFields:productSelected')}</a>
                </Col>
                : <></>}
              <Col span={24}>
                <Button type="dashed" onClick={() => controller.modalOpen = true}>{i.t('def:actions.select')}</Button>
              </Col>
            </>
          ) : <></>}
        </Row>

      </form>

      <Modal
        open={controller.modalOpen}
        footer={null}
        onCancel={() => controller.modalOpen = false}
        width={1000}
        centered={true}
        maskClosable={false}
        className="cpl__modal"
      >
        <Button
          type="primary"
          onClick={() => controller.saveProduct()}
          className="cpl__modal-close"
        >{i.t('def:actions.save')}</Button>

        <SelectProduct
          elementID={__select.select.value}
          element={controller.item.product_id ?? null}
        />


      </Modal>
    </>
  )
})